import { render, staticRenderFns } from "./form-version.vue?vue&type=template&id=7cfbb646&"
import script from "./form-version.vue?vue&type=script&lang=js&"
export * from "./form-version.vue?vue&type=script&lang=js&"
import style0 from "vue-swatches/dist/vue-swatches.min.css?vue&type=style&index=0&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"
import style2 from "./form-version.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports